import { render, staticRenderFns } from "./SecondGradAndTransferResult.vue?vue&type=template&id=17df2eb8&scoped=true&"
import script from "./SecondGradAndTransferResult.vue?vue&type=script&lang=ts&"
export * from "./SecondGradAndTransferResult.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGradAndTransferResult.vue?vue&type=style&index=0&id=17df2eb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df2eb8",
  null
  
)

export default component.exports